import { normalizeOpeningHours } from '../constants/openingHours';
export const formatDate = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return new Intl.DateTimeFormat('he-IL', {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(date);
};
export const placeLabel = (place) => {
  if (!place) return '-';
  return place.name?.he || place.name?.en || place.placeId || '-';
};
export const langValue = (value) => {
  return value?.he || value?.en || '-';
};
export const asArrayText = (value) => {
  return Array.isArray(value) ? value.join(', ') : '';
};
export const parseList = (value) => {
  return String(value || '')
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);
};
export const formatOpeningSummary = (openingHours = []) => {
  const days = normalizeOpeningHours(openingHours);
  return days
    .map(
      (day) =>
        `${day.name}: ${day.ranges.length ? day.ranges.map((range) => (range.isOpen24Hours ? '24 שעות' : `${range.open}-${range.close}`)).join(', ') : 'סגור'}`,
    )
    .join(' | ');
};
